
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { InventoryItem } from "./inventoryTypes";
import { useInventoryOperations } from "./inventoryService";

interface ReturnItemDialogProps {
  item: InventoryItem;
  open: boolean;
  onClose: (success: boolean) => void;
}

export function ReturnItemDialog({ item, open, onClose }: ReturnItemDialogProps) {
  const [location, setLocation] = useState<string>("");
  const { handleItemStatusUpdate } = useInventoryOperations();

  const handleReturn = async () => {
    if (!location.trim()) return;
    
    const success = await handleItemStatusUpdate(
      item.id,
      "Available",
      null,
      location.trim()
    );
    
    onClose(success);
  };

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Return Item</DialogTitle>
          <DialogDescription>
            Return {item.serial} from {item.assignee_name} and specify a storage location
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="location">Storage Location</Label>
            <Input
              id="location"
              placeholder="e.g., Office Cabinet, Storage Room B"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              Enter where the item will be stored after being returned
            </p>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onClose(false)}>
            Cancel
          </Button>
          <Button 
            onClick={handleReturn}
            disabled={!location.trim()}
          >
            Return Item
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
